import React from "react"
import { Persona } from "../../models"
import { Button, Checkbox, TableCell, TableRow, Tooltip } from "@mui/material"
import { Link } from "react-router-dom"
import { useCurrentUser } from "../../hooks/useCurrentUser"

interface PersonaTableRowProps {
  persona: Persona
  restore: boolean
  dark: boolean,
  selected: boolean,
  onPersonaView?: (persona: Persona) => void
  onPersonaCopy?: (persona: Persona) => void
  onPersonaSelect?: (persona: Persona) => void
}

export const PersonaTableRow: React.FC<PersonaTableRowProps> = ({
  persona,
  restore,
  dark,
  selected,
  onPersonaView,
  onPersonaCopy,
  onPersonaSelect,
}) => {
  const user = useCurrentUser()

  return (
    <TableRow className={dark ? 'dark_row' : 'light_row'}>
      <TableCell style={{ padding: "0.25rem 2.25rem" }}>
        <Checkbox className="table_cell" checked={selected} onChange={() => onPersonaSelect?.(persona)}></Checkbox>
      </TableCell>
      <TableCell className="table_cell" style={{ padding: "0.25rem 1rem 0.25rem 0.5rem" }}>{persona.id}</TableCell>
      <TableCell className="table_cell" style={{ padding: "0.25rem 1rem 0.25rem 1rem" }}>
        <Tooltip
          title={
            <div style={{ fontSize: "16px" }}>
              {persona.name}
            </div>
          }
          aria-label="add"
        >
          <div
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {persona.name}
          </div>
        </Tooltip>
      </TableCell>
      <TableCell className="table_cell" style={{ padding: "0.25rem 1rem 0.25rem 0.5rem" }}>
        <Tooltip
          title={
            <div style={{ fontSize: "16px" }}>
              {persona.profileName}
            </div>
          }
          aria-label="add"
        >
          <div
            style={{
              fontSize: "16px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {persona.profileName}
          </div>
        </Tooltip>
      </TableCell>
      <TableCell className="table_cell">
        <span style={{ textTransform: 'capitalize' }}>{persona.type}</span>
      </TableCell>
      <TableCell className="table_cell">
        {persona.company?.name ?? <em>Unassigned</em>}
      </TableCell>
      <TableCell style={{ padding: "0.25rem 1rem 0.25rem 1.5rem" }}>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <Button component={Link} to={!user?.perms.p2 ? `/new-personas` : `/new-personas/${persona.id}`} disabled={!user?.perms.p2} size="small" variant="contained" color="secondary">
            Edit
          </Button>
          {!restore && <Button onClick={() => onPersonaView?.(persona)} size="small" variant="contained" color="secondary">View</Button>}
          <Button disabled={!user?.perms.p1} onClick={() => onPersonaCopy?.(persona)} size="small" variant="contained" color="secondary">
            Copy
          </Button>
        </div>
      </TableCell>
    </TableRow>
  )
}
